export default __webpack_public_path__ + "static/media/learose-1440w.d41f0945.png";